<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <div class="row w-100">
              <div class="col-md-6">
                <div class="pe-md-3 d-flex align-items-center w-50">
                  <InputGroup>
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="keyword" @keyup="getData(keyword)" type="text" class="form-control"
                      placeholder="Type here...">
                  </InputGroup>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-row-reverse gap-2">
                  <ArgonButton isRouteLink :to="{ name: 'Master Data Kpi Create' }">Buat Baru</ArgonButton>
                </div>
              </div>
            </div>
          </template>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr class="text-center">
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Kode KPI</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Indikator</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Bobot</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Target</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Satuan</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Pencapaian</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in data" :key="index">
                  <td>{{ item.code ?? "" }}</td>
                  <td>{{ item.title ?? "" }}</td>
                  <td>{{ item.weight ?? "" }}</td>
                  <td>{{ item.target ?? "" }}{{ item.unit ?? "" }}</td>
                  <td>{{ item.unit ?? "" }}</td>
                  <td>{{ item.achievement ?? "" }}{{ item.unit ?? "" }}</td>
                  <td class="align-middle">
                    <three-dots-menu>
                      <router-link :to="{ name: 'Master Data Kpi Edit', params: { id: item?.id ?? 0 } }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Edit user">Edit</router-link>
                      <button @click.prevent="deleteData(item.id)" class="text-secondary font-weight-bold text-xs btn btn-link"
                        role="link" data-toggle="tooltip" data-original-title="Delete user">Hapus</button>
                    </three-dots-menu>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CardComponent>
      </div>
    </div>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import KpiApi from '@/repository/api/KpiApi';
import ArgonButton from '@/components/ArgonButton.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
export default {
  name: "tables",
  components: {
    CardComponent,
    InputGroup,
    ArgonButton,
    ThreeDotsMenu,
  },
  data() {
    return {
      timer: undefined,
      data: [{}],
      keyword: "",
    };
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    async getData(keyword = "") {
      clearTimeout(this.timer)
      if (keyword.length <= 0) {
        await this.getDataAll();
      }
      else if (keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          await KpiApi.getByKeyword(keyword).then((response) => {
            this.data = response.data;
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: error.response.data.message,
            });
          });
        }, 1500)
      }
    },
    getEmployePhoto(path) {
      return "http://localhost:9100" + path;
    },
    async getDataAll() {
      this.$store.state.loading = true;
      await KpiApi.get().then((response) => {
        this.data = response.data;
      })
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await KpiApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error.response.data.message,
            });
          });
          this.$store.state.loading = false;
        }
      })
    }
  },
};
</script>
